import React from 'react';
import { motion } from 'framer-motion';
import { services } from '@/constants/data';

const ServicesSection = () => (
  <section id="servicos" className="py-16 sm:py-20 lg:py-28 bg-[#F8FAFC]" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        className="text-center mb-10 sm:mb-16">
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-[#0A2463] uppercase">Nossos Serviços</h2>
        <p className="text-[#475569] text-sm sm:text-base lg:text-lg font-body mt-3 sm:mt-4 max-w-2xl mx-auto">
          Soluções completas em audiovisual para transformar seu evento em uma experiência inesquecível.
        </p>
      </motion.div>

      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6">
        {services.map((service, i) => (
          <motion.div key={service.id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08 }}
            data-testid={`service-card-${service.id}`}
            className="group bg-white rounded-2xl overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.06)] border border-slate-100 hover:-translate-y-2 transition-all duration-300">
            <div className={`aspect-[16/10] overflow-hidden ${service.id === 6 ? 'bg-gradient-to-br from-[#EEF4FA] to-[#D6E8F7] flex items-center justify-center p-2' : ''}`}>
              <img src={service.image} alt={service.name}
                className={`group-hover:scale-105 transition-transform duration-700 ${service.id === 6 ? 'w-full h-full object-contain scale-125' : 'w-full h-full object-cover'}`} />
            </div>
            <div className="p-3 sm:p-5">
              <div className="flex items-center gap-1.5 sm:gap-2 mb-1 sm:mb-2">
                <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-lg bg-[#00A8E8]/10 flex items-center justify-center">
                  <service.icon size={14} className="text-[#00A8E8] sm:hidden" />
                  <service.icon size={16} className="text-[#00A8E8] hidden sm:block" />
                </div>
                <h3 className="font-heading text-sm sm:text-xl text-[#0A2463] uppercase leading-tight">{service.name}</h3>
              </div>
              <p className="text-[#475569] text-xs sm:text-sm font-body leading-relaxed hidden sm:block">{service.description}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection;
